import React from "react";
import { NavLink } from "react-router-dom";
import { fireActionTriggerCustomEvent } from "../../utils/adobe-launch";
import { handleEventInfoData } from "../../utils/storeConverter";

import { stores } from "../../data/Stores";
import courtneyLogo from "../../assets/hero/courtneyLogo.png";
import mapMenuIcon from "../../assets/hero/map-icon.png";
import exitButton from "../../assets/hero/btn-close-active (1).png";

import emptyFloorOne from "../../assets/map-images/map-first-floor.png";
import emptyFloorTwo from "../../assets/map-images/map-second floor.png";

import "./Menu.css";

function Menu(props) {
  const floor1Stores = stores.slice(0, 4);
  const floor2Stores = stores.slice(4, stores.length);
  const filteredFloor2Stores = floor2Stores.filter((store) => store.title !== "Smiley's Arcade");

  const Floor = (props) => {
    return (
      <div className="floorInfoBorder">
        <div className="floorInfoHolder">
          <div className="mapImageHolder">
            <h2 className="mapTitle">{props.title}</h2>
            <img
              className="storeMapImage"
              alt={`map:${props.title}`}
              src={props.png}
            />
          </div>
          <div className="storeListContainer">
            <ul>
              {props.storeArr.map((i) => (
                <li
                  className="storeLinkWrapper"
                  data-store={i}
                  key={"link-" + i.id}
                >
                  <NavLink
                    className={`storeLink ${
                      props.currentStoreNum === i.id ? "active" : ""
                    }`}
                    exact
                    to={`/store/${i.id}`}
                    data-id={i.id}
                    data-camera={i.camera}
                    onClick={(e) => {
                      props.changeStoreNum(i.id);
                      props.handleMenuToggle();
                      handleEventInfoData({
                        storeName: window.digitalData.pageInfo.page_name,
                        page_name:
                          window.digitalData.pageInfo.page_name +
                          `:${i.title} store link`,
                        location_name: `Main Nav`,
                      });
                      fireActionTriggerCustomEvent(
                        e.target,
                        window.digitalData.event
                      );
                    }}
                  >
                    <img
                      className="mapIconImage"
                      alt={`${i.title} map icon`}
                      src={
                        props.currentStoreNum !== i.id
                          ? i.images.darkIcon
                          : i.images.lightIcon
                      }
                    />

                    <p className="storeLinkText">{i.title}</p>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  };

  const firstFloor = (
    <Floor
      title="First Floor Mall Map"
      currentStoreNum={props.currentStoreNum}
      changeStoreNum={props.changeStoreNum}
      handleMenuToggle={props.menuToggle}
      png={stores[props.currentStoreNum - 1].images.mapImage || emptyFloorOne}
      storeArr={floor1Stores}
    />
  );

  const secondFloor = (
    <Floor
      currentStoreNum={props.currentStoreNum}
      handleMenuToggle={props.menuToggle}
      changeStoreNum={props.changeStoreNum}
      title="Second Floor Mall Map"
      png={stores[props.currentStoreNum - 1].images.mapImage || emptyFloorTwo}
      storeArr={filteredFloor2Stores}
    />
  );

  return (
    <nav className={props.openMenu ? "MainNav open background" : "MainNav"}>
      <div
        className="menu"
        onClick={(e) => {
          props.menuToggle();
          handleEventInfoData({
            storeName: window.digitalData.pageInfo.page_name,
            page_name: window.digitalData.pageInfo.page_name + ":open map",
            location_name: `Main Nav Menu`,
          });
          fireActionTriggerCustomEvent(e.target, window.digitalData.event);
        }}
      >
        <img alt="map icon" src={mapMenuIcon} />
      </div>

      <div className="map">
        <img className="courtneyLogo" src={courtneyLogo} alt="Courtney Logo" />
        <div
          className="close"
          onClick={(e) => {
            props.menuToggle();
            handleEventInfoData({
              storeName: window.digitalData.pageInfo.page_name,
              page_name: window.digitalData.pageInfo.page_name + ":close map",
              location_name: `Main Nav Menu`,
            });
            fireActionTriggerCustomEvent(e.target, window.digitalData.event);
          }}
        >
          <img src={exitButton} alt="exit button" />
        </div>

        <div className="mapHolder">
          {props.isFloorOne ? firstFloor : secondFloor}
          <div className="floorButtons">
            <button
              className={props.isFloorOne ? "active" : "disabled"}
              disabled={props.isFloorOne ? "disabled" : null}
              onClick={ (e) => {
                props.changeFloorOne();
                handleEventInfoData({
                  storeName: window.digitalData.pageInfo.page_name,
                  page_name: window.digitalData.pageInfo.page_name + ":show floor one",
                  location_name: `Main Nav Menu`,
                });
                fireActionTriggerCustomEvent(e.target, window.digitalData.event);
              }}
            >
              First Floor
            </button>
            <button
              className={!props.isFloorOne ? "active" : "disabled"}
              disabled={!props.isFloorOne ? "disabled" : null}
              onClick={(e ) => {
                props.changeFloorOne();
                handleEventInfoData({
                  storeName: window.digitalData.pageInfo.page_name,
                  page_name: window.digitalData.pageInfo.page_name + ":show floor 2",
                  location_name: `Main Nav Menu`,
                });
                fireActionTriggerCustomEvent(e.target, window.digitalData.event);
              }}
            >
              Second Floor
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Menu;
